export default __webpack_public_path__ + "static/media/Q9_3_resized.b32d520a.jpg";